import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=b38794c8&scoped=true&"
import script from "./SearchForm.vue?vue&type=script&lang=ts&"
export * from "./SearchForm.vue?vue&type=script&lang=ts&"
import style0 from "./SearchForm.vue?vue&type=style&index=0&id=b38794c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38794c8",
  null
  
)

export default component.exports